//
// DimensionalSortContext.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../../moduleBuilder";
import ClosetObject from "../../../ClosetObject";
import "../../../lib";
import "./SortContext";
import "./HierarchySortContext";

var DimensionalSortContext = createModule("commons::DimensionalSortContext", ["commons::SortContext"], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        setSortForCategory: [0,1,1],
        getSortForCategory: [1,1],
    },
    {
        _create: [4],
    },
    ,
]);
export default DimensionalSortContext;
